import { setCart } from "store/actions/storeActions";
import { store } from "store/configureStore";
import { axiosApi } from "./helper";

/**
 * GET ALL PRODUCTS
 */
export function getProducts(obj) {
  return axiosApi("gifts", obj, "get");
}

/**
 * GET PRODUCT BY ID
 * @param {*} id
 */
export function getProduct(id) {
  return axiosApi("gift/" + id, {}, "get");
}

/**
 * ADD PRODUCT TO CART
 * @param {*} ean EAN Product
 * @param {*} obj Quantity
 */
export function addProductToCart(ean, quantity) {
  return axiosApi("cart/gift/" + ean, { quantity }, "put");
}

/**
 * GET USER CART
 */
export function getCart() {
  return axiosApi("cart", {}, "get");
}

/**
 * CLEAR USER CART
 */
export function clearCart() {
  return axiosApi("cart", {}, "delete");
}

export function refreshCart() {
  console.log("Refreshing cart");
  return new Promise((resolve, reject) => {
    getCart().then(
      (data) => {
        console.log("Cart was refreshed");
        store.dispatch(setCart(data));
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

/**
 * REMOVE PRODUCT TO CART
 * @param {*} ean EAN Product
 * @param {*} obj Quantity
 */
export function removeProductToCart(ean, quantity) {
  const params = {};
  if (quantity > 0) {
    params.quantity = quantity;
  }
  return axiosApi("cart/gift/" + ean, params, "delete");
}

/**
 * SEND THE ORDER
 */
export function sendUserOrder(address) {
  return axiosApi("order", address, "post");
}

/**
 * GET CATEGORIES
 */
export function getCategories() {
  return axiosApi("categories", {}, "get");
}

/**
 * SET CATEGORIES
 */
export function setFilter(obj) {
  return axiosApi("gifts/filtering", obj, "get");
}

export function groupProduct(groupId) {
  return axiosApi("product-catalog/usergroup/" + groupId, {}, "get");
}
